<template>
  <div id="app" class="appHolder">
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> |
      <router-link to="/login">Login</router-link> |
      <router-link to="/Forgot">Forgot</router-link> |
      <router-link to="/SetNewPassword">SetNewPassword</router-link> |
      <router-link to="/dashboard">Dashboard</router-link>
    </div>
    <router-view />
    <div class="loading primary transition-cubic fCol jCenter aCenter "
      v-bind:class="{hide: !loading}">
      <div class="p"></div>
    </div>
  </div>
</template>

<script>
import Theming from '@/mixins/theming';

export default {
  mixins: [Theming],
  data() {
    return {
    };
  },
  computed: {
    loading() {
      return this.$store.state.superLoading;
    },
  },
  watch: {
    loading() {
    },
  },
  methods: {
  },
  mounted() {
    this.ThemeInit();
    // const appDefinition = {
    //   name: 'rimik',
    //   faName: 'ریمیک',
    //   url: 'https://api.rimik.ir',
    //   home: 'https://panel.rimik.ir',
    //   site: 'https://rimik.ir',
    //   theme: {
    //     mode: 'light',
    //     primary: '#3d21ae',
    //     secondary: '#251956',
    //     normalText: '#343434',
    //     darkText: '#131313',
    //     invertText: '#fafafa',
    //     themeBackground: '#e0e0e0',
    //     themeSurface: '#f0f0f0',
    //     themeGreen: '#40aa45',
    //     themeRed: '#be2c00',
    //     themeOrange: '#cfa122',
    //     shade0: '#0f0f0f',
    //     shade1: '#2b2b2b',
    //     shade2: '#3f3f3f',
    //     shade3: '#4f4f4f',
    //     shade4: '#6f6f6f',
    //     shade5: '#808080',
    //     themeWhite: '#f8f8f8',
    //     themeBlack: '#0f0f0f',
    //     themeBlue: '#2841a7',
    //     color1: '#9B6CAD',
    //     color2: '#ffd257',
    //     color3: '#6a2f82',
    //     color4: '#2b5776',
    //     color5: '#224f3c',
    //     color6: '#534636',
    //     color7: '#4d965f',
    //     color8: '#6a5b47',
    //     color9: '#3f4391',
    //     color10: '#51268c',
    //   },
    // };
  },
};
</script>

<style lang="scss" scoped>
@keyframes l {
  0% {
    transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
    -moz-transform: rotate(-360deg);
    -webkit-transform: rotate(-360deg);
    -ms-transform: rotate(-360deg);
    -o-transform: rotate(-360deg);
  }
}
.appHolder {
  position: relative;
  color: var(--normalText);

  .loading{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-image: url('./assets/lines.svg');
    z-index: 99999999999999999999;
  }

  .p{
    width: 24px;
    height: 24px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url('./assets/load.svg');
    animation: l linear 1s infinite;
  }

  .loading.hide{
    transform: translateY(-100%);
    -webkit-transform: translateY(-100%);
    -moz-transform: translateY(-100%);
    -o-transform: translateY(-100%);
    -ms-transform: translateY(-100%);
  }
}
</style>
